import React from 'react';
import Spinner from 'react-spinner';
import DiversionTable from './DiversionTable';

import fetchContent from '../../helpers/backend-communication';

class DiversionList  extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      isLoading: false,
      data: [],
    };

    this.onLoading = this.onLoading.bind(this);
  }

  fetchData(onLoading) {
    this.onLoading(true);
    fetchContent('diversionCountry')
      .then(responseObject => {
        this.setState({
          data: responseObject.data,
        });
        this.onLoading(false);
      })
      .catch(error => {
        console.error('Fetch went wrong', error);
        this.onLoading(false);
      });
  }
  componentDidMount() {
    this.fetchData(
      this.props.onLoading
    );
  }

  onLoading(isLoading) {
    this.setState({ isLoading });
  }


  renderContent() {
    let content;

    if (this.state.isLoading || this.state.data.length == 0) {
      content = (
        <div className="assistance-page-panel__spinner">
          <Spinner />
        </div>
      );
    } else {
        content = (
        <div>
          <DiversionTable
            data={ this.state.data }
            hasItem={this.props.hasItem}
            description={this.props.description}
            number={this.props.number}
            type ={"test"}
          />
        </div>
        );
    }

    return content;
  }

  render() {
    return (
      <div className="container-fluid">
        { this.renderContent() }
      </div>
    )
  }
}

export default DiversionList;



// WEBPACK FOOTER //
// ./src/components/Diversion/DiversionList.js